import React from "react";
import { List, Item } from "./styles";

export const ContactBar = () => (
  <List>
    <Item>01686 624162</Item> <Item>pughmotors@hotmail.co.uk</Item>{" "}
  </List>
);
